/**
 * QA FAIL 15.10.2026 (TestFlight, из РФ) — «Начать Live-сессию» крутила лоадер
 * без конца, на iPhone и iPad.
 *
 * Обложка уходит первой, и её загрузку нативная страховка сети
 * (`nativeApiFallback`) нарочно не ограничивает по времени и не повторяет через
 * московский эдж: на медленном LTE загрузка законно дольше 8 с. Подвисший из РФ
 * прямой хост не отвечал вовсе, `await` не заканчивался, и кнопка крутилась,
 * пока iOS не рвала соединение при сворачивании — тогда текст возвращался, а
 * следующее нажатие снова висло.
 *
 * Потолок — у кнопки: дольше минуты на обложку мастер не ждёт, а получает
 * объяснение и снова живую кнопку. Сам запрос не обрывается (его отмена
 * потребовала бы правки общего с вебом api.ts): опоздавший ответ оставит на
 * сервере лишний файл, сессия от этого не задвоится — она ещё не создавалась.
 */
export const COVER_UPLOAD_TIMEOUT_MS = 60_000;

export const COVER_UPLOAD_TIMEOUT_MESSAGE =
  'Обложка не загрузилась: сервер не ответил. Проверьте связь и попробуйте ещё раз или уберите обложку.';

export class CoverUploadTimeoutError extends Error {
  constructor() {
    super(COVER_UPLOAD_TIMEOUT_MESSAGE);
    this.name = 'CoverUploadTimeoutError';
  }
}

/** Загрузка обложки с потолком: не успела за `ms` — `CoverUploadTimeoutError`. */
export function uploadCoverWithCeiling<T>(upload: Promise<T>, ms: number = COVER_UPLOAD_TIMEOUT_MS): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => reject(new CoverUploadTimeoutError()), ms);
    upload.then(
      (value) => { clearTimeout(timer); resolve(value); },
      (error) => { clearTimeout(timer); reject(error); },
    );
  });
}
